import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=7c6e4972&scoped=true&"
import script from "./brand.vue?vue&type=script&lang=js&"
export * from "./brand.vue?vue&type=script&lang=js&"
import style0 from "./brand.vue?vue&type=style&index=0&id=7c6e4972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6e4972",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrandHero: require('/opt/render/project/src/channels2022/src/components/brand-design-kit/BrandHero.vue').default,BrandKitLogo: require('/opt/render/project/src/channels2022/src/components/brand-design-kit/BrandKitLogo.vue').default})
